import { Input, Radio, Space } from 'antd'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useState } from 'react'
import { Button, Col, Row, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import GuideButtons from 'sections/Dashboard/features/SetupGuide/components/GuideButtons'
import { ASSIGNABLE_ROLES, EMAIL_RX } from 'services/constants'
import { AddPeopleContainer } from './style'

function AddPeople({ onNext, onPrevious, invites, setInvites }) {
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [role, setRole] = useState('reader')
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
  })

  const removeInvite = (targetIndex) => {
    setInvites(invites.filter((_, i) => i !== targetIndex))
  }

  const addInvite = () => {
    if (role !== null) {
      const trimmedEmail = email.trim()
      const trimmedFirstName = firstName.trim()
      const trimmedLastName = lastName.trim()

      const newErrors = { firstName: '', lastName: '', email: '' }
      if (!trimmedFirstName) newErrors.firstName = 'First name is required'
      if (!trimmedLastName) newErrors.lastName = 'Last name is required'
      if (!EMAIL_RX.test(trimmedEmail))
        newErrors.email = 'Invalid email address'

      if (Object.values(newErrors).every((val) => !val)) {
        const invite = {
          name: trimmedFirstName + ' ' + trimmedLastName,
          email: trimmedEmail,
          role,
        }
        setInvites([...invites, invite])
        setFirstName('')
        setLastName('')
        setEmail('')
        setErrors({ firstName: '', lastName: '', email: '' })
      } else {
        setErrors(newErrors)
      }
    }
  }

  return (
    <AddPeopleContainer className="card-body-container">
      <div className="card card-body">
        <div className="progressbar-container">
          <div className="text-left mt-3">
            <h4>{t('book_setup_guide_fourth_title')}</h4>
          </div>

          <div className="text-left mt-5 mb-5">
            <Row className="mb-3">
              <Col md={{ span: 6 }}>
                <Row className="mb-3">
                  <Col md={{ span: 4 }}>
                    <label>{t('first_name')}</label>
                  </Col>
                  <Col md={{ span: 8 }}>
                    <Input
                      size="large"
                      onChange={(e) => {
                        setFirstName(e.target.value)
                        setErrors((prev) => ({ ...prev, firstName: '' }))
                      }}
                      value={firstName}
                      placeholder={t('first_name')}
                    />
                    {errors.firstName && (
                      <div className="error">{errors.firstName}</div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={{ span: 4 }}>
                    <label>{t('last_name')}</label>
                  </Col>
                  <Col md={{ span: 8 }}>
                    <Input
                      size="large"
                      onChange={(e) => {
                        setLastName(e.target.value)
                        setErrors((prev) => ({ ...prev, lastName: '' }))
                      }}
                      value={lastName}
                      placeholder={t('last_name')}
                    />
                    {errors.lastName && (
                      <div className="error">{errors.lastName}</div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={{ span: 4 }}>
                    <label>{t('email')}</label>
                  </Col>
                  <Col md={{ span: 8 }}>
                    <Input
                      size="large"
                      onChange={(e) => {
                        setEmail(e.target.value)
                        setErrors((prev) => ({ ...prev, email: '' }))
                      }}
                      value={email}
                      placeholder={t('email')}
                    />
                    {errors.email && (
                      <div className="error">{errors.email}</div>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col
                md={{ span: 2 }}
                className="modal-roles mt-3 mb-3"
                style={{ padding: '0px' }}
              >
                <Radio.Group
                  onChange={(e) => setRole(e.target.value)}
                  value={role}
                >
                  <Space direction="vertical" size={16}>
                    {Object.values(ASSIGNABLE_ROLES).map((role) => (
                      <Radio key={role.id} value={role.id}>
                        <small>{role[`label_${lang}`]}</small>
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Col>
              <Col md={{ span: 4 }}>
                <Row className="mb-2">
                  <Col md={{ span: 12 }}>
                    {role === null ? (
                      <p
                        style={{
                          fontSize: '14px',
                          marginBottom: '0px',
                        }}
                      >
                        {t('book_setup_guide_fourth_content')}{' '}
                        <span style={{ fontWeight: '900' }}>
                          {t('see_example')}
                        </span>
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: '14px',
                          marginBottom: '0px',
                        }}
                      >
                        {ASSIGNABLE_ROLES[role][`description_${lang}`]}
                      </p>
                    )}
                  </Col>
                  <Col md={{ span: 12 }}>
                    <Button
                      onClick={addInvite}
                      className="btn-blue btn-dash mt-3"
                      style={{
                        width: '100%',
                        height: '25px',
                        padding: '0 16px',
                      }}
                    >
                      {t('add_to_invite_list')}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {invites.length > 0 ? (
        <div className="card card-body">
          <div className="progressbar-container">
            <div className="text-left">
              <Row>
                <Col md={{ span: 12 }}>
                  <Table>
                    <tbody>
                      {invites.map((invite, i) => (
                        <tr className="invitees-row" key={i}>
                          <td>{invite.name}</td>
                          <td align="left">{invite.email}</td>
                          <td align="left">{invite.role}</td>
                          <td align="left">
                            <button
                              onClick={() => removeInvite(i)}
                              style={{
                                fontWeight: '400',
                                backgroundColor: 'transparent',
                                fontSize: '0.875rem',
                              }}
                            >
                              REMOVE
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <GuideButtons onNext={onNext} onPrevious={onPrevious} />
    </AddPeopleContainer>
  )
}

export default AddPeople
